import React from "react";
import { connect } from "react-redux";
import { Form, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { PatternFormat as NumberFormat } from 'react-number-format';

import { deepEqual } from "../../utils/object";
import { phoneInputValue } from "../../utils/string";
import { calculate } from "../../utils/validation";

import GenerationsSelect from "../../layout/select/generation";
import Address from "../../layout/address";
import CsLineIcons from "../../cs-line-icons";

import 'react-datepicker/dist/react-datepicker.css';

class Personal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...props
        };
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(this.props, oldProps)) {
            var __props_minus_fields = { ...this.props };
            var __old_minus_fields = { ...oldProps };
            delete __props_minus_fields.fields;
            delete __old_minus_fields.fields;
            delete __old_minus_fields.file;
            delete __props_minus_fields.file;

            if (!deepEqual(__props_minus_fields, __old_minus_fields)) {
                this.setState({
                    ...this.state,
                    ...this.props
                });
            } 
            if (this.props.fields.length !== oldProps.fields.length)
                this.sendOnChange();
        }
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        }, this.sendOnChange)
    }

    onGenerationChange = (e) => {
        this.onChange({ target: { name: "generation", value: e.value } });
    }


    onAddressChange = (e) => {
        this.setState({
            ...this.state,
            Residence: {
                ...this.state.Residence,
                ...e
            }
        }, this.sendOnChange);
    }

    onPhoneChange = (e) => {
        this.setState({
            ...this.state,
            Phone: {
                ...this.state.Phone,
                number: e.target.value
            }
        }, this.sendOnChange);
    }

    sendOnChange = () => {
        if (this.props.onChange) {
            this.props.onChange({ ...this.state }, calculate(this.props.fields, "PROFILE", this.state));
        }
    }

    render() {
        return (
            <div className="licensee-editor-sections">
                <section className="licensee-editor-card">
                    <header className="licensee-editor-card-header">
                        <span><CsLineIcons icon="user" size="21" /></span>
                        <h2>Personal Information</h2>
                    </header>
                    <Row>
                        <Col lg="12">
                        <Row className="g-3">
                            <Col lg="4">
                                <div className="mb-3 licensee-field">
                                    <Form.Label>FIRST NAME</Form.Label>
                                    <Form.Control type="text" name="firstName" value={this.state.firstName || ""} onChange={this.onChange} />
                                </div>
                            </Col>
                            <Col lg="2">
                                <div className="mb-3 licensee-field">
                                    <Form.Label>MIDDLE NAME</Form.Label>
                                    <Form.Control type="text" name="middleName" value={this.state.middleName || ""} onChange={this.onChange} />
                                </div>
                            </Col>
                            <Col lg="4">
                                <div className="mb-3 licensee-field">
                                    <Form.Label>LAST NAME</Form.Label>
                                    <Form.Control type="text" name="lastName" value={this.state.lastName || ""}  onChange={this.onChange} />
                                </div>
                            </Col>
                            <Col lg="2">
                                <div className="mb-3 licensee-field">
                                    <Form.Label>SUFFIX</Form.Label>
                                    <GenerationsSelect value={this.state.generation || ""} onChange={this.onGenerationChange} placeholder="" name="generation" />
                                </div>
                            </Col>
                        </Row>
                        </Col>
                    </Row>
                </section>

                <section className="licensee-editor-card">
                    <header className="licensee-editor-card-header">
                        <span><CsLineIcons icon="home" size="21" /></span>
                        <h2>Address</h2>
                    </header>
                    <Address {...this.state.Residence} onChange={ this.onAddressChange } rowClassName="g-3" />
                </section>

                <section className="licensee-editor-card">
                    <header className="licensee-editor-card-header">
                        <span><CsLineIcons icon="phone" size="21" /></span>
                        <h2>Phone Number</h2>
                    </header>
                    <Row className="g-3">
                        <Col lg="12">
                        <div className="mb-3">
                            <NumberFormat format="(###) ###-####" mask="_" className="form-control" value={phoneInputValue(this.state.Phone?.number)} allowEmptyFormatting onChange={this.onPhoneChange} name="Phone.number" />
                        </div>
                        </Col>
                    </Row>
                </section>
            </div>
        )
    }
}

Personal.propTypes = {
    fields: PropTypes.array,
};

const mapStateToProps = (state) => {
    return ({
        fields: state.fields.items
    });
};

export default connect(mapStateToProps)(Personal);
